import { Directive, forwardRef, inject } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MtxSelect } from '@ng-matero/extensions/select';

// @typescript-eslint/no-use-before-define
// necessary since ng-matero ng-select does not properly export the mat-select as a NG_VALUE_ACCESSOR
@Directive({
  selector: 'mtx-select[ngrxFormControlState]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,

      useExisting: forwardRef(() => NgrxMatSelectViewAdapterDirective),
      multi: true,
    },
  ],
  standalone: false,
})
export class NgrxMatSelectViewAdapterDirective implements ControlValueAccessor {
  private mtxSelect = inject(MtxSelect);

  writeValue(obj: any): void {
    this.mtxSelect?.writeValue(obj);
  }

  registerOnChange(fn: any): void {
    this.mtxSelect.registerOnChange(fn);
  }

  registerOnTouched(fn: any): void {
    this.mtxSelect.registerOnTouched(fn);
  }

  setDisabledState?(isDisabled: boolean): void {
    this.mtxSelect.setDisabledState(isDisabled);
  }
}
